export default "__VITE_ASSET__cc8ea8e7__"